/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_Cta_TitleInputs */

const en_hub_cta_title = /** @type {(inputs: Hub_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bring your markdown, keep your tools`)
};

const id_hub_cta_title = /** @type {(inputs: Hub_Cta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bawa markdown Anda, pertahankan alat Anda`)
};

/**
* | output |
* | --- |
* | "Bring your markdown, keep your tools" |
*
* @param {Hub_Cta_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_cta_title = /** @type {((inputs?: Hub_Cta_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_Cta_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_cta_title(inputs)
	return en_hub_cta_title(inputs)
});